import { render, staticRenderFns } from "./DynamicField.vue?vue&type=template&id=4bc21164&"
import script from "./DynamicField.vue?vue&type=script&lang=js&"
export * from "./DynamicField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicField.vue?vue&type=style&index=0&id=4bc21164&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports